import React from 'react'
import { withRouter } from 'react-router-dom'
import find from 'lodash/find'
import TopPageHeader from '../pageHeaders/TopPageHeader'
import DiscoverExcludedMarkets from './DiscoverExcludedMarkets'
import Icon from '../misc/Icons'
import ComplexIcon from '../misc/ComplexIcons'
import discoverRepoIds from '../../staticData/discoverRepoIds'
import DiscoverSubjectPageFooter from './DiscoverSubjectPageFooter'
import analytics from '../../utils/cdpAnalytics'

const { biologyRepoShortIds } = discoverRepoIds
// ALL Early Math
const { mathsRepoShortIds } = discoverRepoIds

const { keyTextsRepoShortIds } = discoverRepoIds

function isSubscribedToMarket(market, subscribedMarkets) {
  if (find(subscribedMarkets, { name: market })) {
    return true
  } return false
}

class DiscoverHomePage extends React.Component {
  constructor() {
    super()
    this.navigateToMarket = this.navigateToMarket.bind(this)
  }

  UNSAFE_componentWillMount() {
    if (this.props.biologyRepos.length !== biologyRepoShortIds.length) {
      biologyRepoShortIds.forEach((shortId) => {
        this.props.fetchAPublishedRepoByShortId(shortId)
          .catch(() => {})
      })
    }

    if (this.props.mathRepos.length !== mathsRepoShortIds.length) {
      mathsRepoShortIds.forEach((shortId) => {
        this.props.fetchAPublishedRepoByShortId(shortId)
          .catch(() => {})
      })
    }

    if (this.props.keyTextRepos.length !== keyTextsRepoShortIds.length) {
      keyTextsRepoShortIds.forEach((shortId) => {
        this.props.fetchAPublishedRepoByShortId(shortId)
          .catch(() => {})
      })
    }
  }

  componentDidMount() {
    analytics.page('Discover Home Page')
  }

  navigateToMarket(e, market) {
    e.stopPropagation()
    setTimeout(() => { // Small delay because it feels a bit nicer
      this.props.history.push(`/discover/${market}`)
    }, 50)
  }

  render() {
    const { subscribedMarkets } = this.props
    const isMiddleScienceSubscribed = isSubscribedToMarket('middleScience', subscribedMarkets)
    return (
      <div className='page page--extraWideLayout discoverHome'>
        <div className='page-leftPanel' />
        <div className='page-centerPanel'>
          <TopPageHeader
            header='Discover'
            location='discoverHome'
            headerInfoRow='Made by Plickers teachers, great starter packs ready to use in your next class.'
          />

          <div className='discoverHome-marketBtnArray'>
            <button className='discoverHome-marketBtn discoverHome-marketBtn--math' onDoubleClick={(e) => { this.navigateToMarket(e, 'earlyMath') }} onClick={(e) => { this.navigateToMarket(e, 'earlyMath') }}>
              <div className='discoverHome-marketBtn-inner'>
                <div className='discoverHome-marketBtn-inner-secondaryIconContainer'>
                  <ComplexIcon name='discoverHomeEarlyMathSecondary' />
                </div>
                <div className='discoverHome-marketBtn-inner-left'>
                  <div className='discoverHome-marketBtn-inner-left-title'>
                    <div className='discoverHome-marketBtn-inner-left-title-text'>
                      Early Math
                    </div>
                    <div className='discoverHome-marketBtn-inner-left-title-chevronContainer'>
                      <Icon name='chevron-right' />
                    </div>
                  </div>
                  <div className='discoverHome-marketBtn-inner-left-subtitle'>
                    2,500+ math questions for young learners
                  </div>
                </div>
                <div className='discoverHome-marketBtn-inner-primaryIconContainer'>
                  <ComplexIcon name='discoverHomeEarlyMathPrimary' />
                </div>
              </div>
            </button>

            <button className='discoverHome-marketBtn discoverHome-marketBtn--ELA' onDoubleClick={(e) => { this.navigateToMarket(e, 'keyTexts') }} onClick={(e) => { this.navigateToMarket(e, 'keyTexts') }}>
              <div className='discoverHome-marketBtn-inner'>
                <div className='discoverHome-marketBtn-inner-secondaryIconContainer'>
                  <ComplexIcon name='discoverHomeELASecondary' />
                </div>
                <div className='discoverHome-marketBtn-inner-left'>
                  <div className='discoverHome-marketBtn-inner-left-title'>
                    <div className='discoverHome-marketBtn-inner-left-title-text'>
                      ELA: Key Texts
                    </div>
                    <div className='discoverHome-marketBtn-inner-left-title-chevronContainer'>
                      <Icon name='chevron-right' />
                    </div>
                  </div>
                  <div className='discoverHome-marketBtn-inner-left-subtitle'>
                    Exploring novels and plays in English Literature
                  </div>
                </div>
                <div className='discoverHome-marketBtn-inner-primaryIconContainer'>
                  <ComplexIcon name='discoverHomeELAPrimary' />
                </div>
              </div>
            </button>

            <button className='discoverHome-marketBtn discoverHome-marketBtn--biology' onDoubleClick={(e) => { this.navigateToMarket(e, 'biology') }} onClick={(e) => { this.navigateToMarket(e, 'biology') }}>
              <div className='discoverHome-marketBtn-inner'>
                <div className='discoverHome-marketBtn-inner-secondaryIconContainer'>
                  <ComplexIcon name='discoverHomeBiologySecondary' />
                </div>
                <div className='discoverHome-marketBtn-inner-left'>
                  <div className='discoverHome-marketBtn-inner-left-title'>
                    <div className='discoverHome-marketBtn-inner-left-title-text'>
                      High School Biology
                    </div>
                    <div className='discoverHome-marketBtn-inner-left-title-chevronContainer'>
                      <Icon name='chevron-right' />
                    </div>
                  </div>
                  <div className='discoverHome-marketBtn-inner-left-subtitle'>
                    Including 1,250+ NGSS-aligned questions
                  </div>
                </div>
                <div className='discoverHome-marketBtn-inner-primaryIconContainer'>
                  <ComplexIcon name='discoverHomeBiologyPrimary' />
                </div>
              </div>
            </button>

            <button className='discoverHome-marketBtn discoverHome-marketBtn--middleScience'>
              <div className='discoverHome-marketBtn-inner'>
                <div className='discoverHome-marketBtn-inner-secondaryIconContainer'>
                  <ComplexIcon name='discoverHomeMiddleScienceSecondary' />
                </div>
                <div className='discoverHome-marketBtn-inner-left'>
                  <div className='discoverHome-marketBtn-inner-left-title'>
                    <div className='discoverHome-marketBtn-inner-left-title-text'>
                      Middle School Science
                    </div>
                  </div>
                  <div className='discoverHome-marketBtn-inner-left-comingSoonBadgeContainer'>
                    <div className='discoverHome-marketBtn-inner-left-comingSoonBadge'>
                      Coming Next
                    </div>
                  </div>
                </div>
                <div className='discoverHome-marketBtn-inner-primaryIconContainer'>
                  <ComplexIcon name='discoverHomeMiddleSciencePrimary' />
                </div>
              </div>
              <div className={`discoverHome-marketBtn-notificationContainer ${isMiddleScienceSubscribed ? 'discoverHome-marketBtn-notificationContainer--subscribed' : 'discoverHome-marketBtn-notificationContainer--notSubscribed'}`}>
                {this.props.meta && !isMiddleScienceSubscribed && (
                <button onClick={() => { this.props.subscribeToExcludedMarket('middleScience') }} className='discoverHome-marketBtn-notificationBtn discoverHome-marketBtn-notificationBtn--notSubscribed'>
                  Notify Me
                  <Icon name='discoverNotificationBell' />

                </button>
                )}
                {this.props.meta && isMiddleScienceSubscribed && (
                <button onClick={() => { this.props.unsubscribeToExcludedMarket('middleScience') }} className='discoverHome-marketBtn-notificationBtn discoverHome-marketBtn-notificationBtn--subscribed'>
                  Subscribed
                </button>
                )}
                {this.props.meta && (
                <svg className='discoverNotificationRibbon' xmlns='http://www.w3.org/2000/svg' width='10' height='19' viewBox='0 0 10 19'>
                  <path fill='red' fillRule='evenodd' stroke='#00FFE3' d='M9.5,0.5 L9.5,6.8911078 C9.5,8.41717536 8.86594462,9.87464012 7.74945122,10.9149885 L7.74945122,10.9149885 L0.5,17.6700257 L0.5,0.5 L9.5,0.5 Z' />
                </svg>
                )}
              </div>
            </button>

            {/*
                <button className='discoverHome-marketBtn' onClick={()=>{this.props.history.push('/discover/keyTexts')}}>
                  <div className='discoverHome-marketBtn-inner'>
                    <div className='discoverHome-marketBtn-inner-text'>
                      ELA: Key Texts
                    </div>
                    <div className='discoverHome-marketBtn-inner-chevronContainer'>
                      <Icon name='chevron-right' />
                    </div>
                  </div>
                </button>

              <button className='discoverHome-marketBtn' onClick={()=>{this.props.history.push('/discover/biology')}}>
                <div className='discoverHome-marketBtn-inner'>
                  <div className='discoverHome-marketBtn-inner-text'>
                    High School Biology
                  </div>
                  <div className='discoverHome-marketBtn-inner-chevronContainer'>
                    <Icon name='chevron-right' />
                  </div>
                </div>
              </button>

              <button className='discoverHome-marketBtn' >
                <div className='discoverHome-marketBtn-inner'>
                  <div className='discoverHome-marketBtn-inner-text'>
                    Middle Science

                    <div className='discoverHome-marketBtn-inner-text-comingSoonBadgeContainer'>
                      <div className='discoverHome-marketBtn-inner-text-comingSoonBadge'>
                        Coming Soon
                      </div>
                    </div>

                  </div>

                  <div className='discoverHome-marketBtn-inner-notificationContainer'>
                    {!isMiddleScienceSubscribed &&
                      <button className='discoverHome-marketBtn-inner-notificationBtn discoverHome-marketBtn-inner-notificationBtn--notSubscribed'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                          <path d="M16.234375,31.109375 C17.3177083,31.109375 18.2786458,30.859375 19.1171875,30.359375 C19.9557292,29.859375 20.6197917,29.1979167 21.109375,28.375 C21.5445602,27.6435185 21.7986754,26.8626543 21.8717207,26.0324074 L21.888,25.75 L28.046875,25.75 C28.7760417,25.75 29.3515625,25.5703125 29.7734375,25.2109375 C30.1953125,24.8515625 30.40625,24.375 30.40625,23.78125 C30.40625,23.0104167 30.1067708,22.2838542 29.5078125,21.6015625 C28.9088542,20.9192708 28.28125,20.25 27.625,19.59375 C27.28125,19.2604167 27.015625,18.8229167 26.828125,18.28125 C26.640625,17.7395833 26.5,17.1510417 26.40625,16.515625 C26.3125,15.8802083 26.2447917,15.2447917 26.203125,14.609375 C26.140625,12.7239583 25.9140625,11.0520833 25.5234375,9.59375 C25.1328125,8.13541667 24.5338542,6.91927083 23.7265625,5.9453125 C22.9192708,4.97135417 21.8645833,4.25 20.5625,3.78125 C20.3020833,2.80208333 19.7890625,1.98177083 19.0234375,1.3203125 C18.2578125,0.658854167 17.328125,0.328125 16.234375,0.328125 C15.1302083,0.328125 14.1953125,0.658854167 13.4296875,1.3203125 C12.6640625,1.98177083 12.1510417,2.80208333 11.890625,3.78125 C10.5885417,4.25 9.53385417,4.97135417 8.7265625,5.9453125 C7.91927083,6.91927083 7.31770833,8.13541667 6.921875,9.59375 C6.52604167,11.0520833 6.30208333,12.7239583 6.25,14.609375 C6.19791667,15.2447917 6.12760417,15.8802083 6.0390625,16.515625 C5.95052083,17.1510417 5.8125,17.7395833 5.625,18.28125 C5.4375,18.8229167 5.171875,19.2604167 4.828125,19.59375 C4.171875,20.25 3.54427083,20.9192708 2.9453125,21.6015625 C2.34635417,22.2838542 2.046875,23.0104167 2.046875,23.78125 C2.046875,24.375 2.2578125,24.8515625 2.6796875,25.2109375 C3.1015625,25.5703125 3.67708333,25.75 4.40625,25.75 L10.564,25.75 L10.5846836,26.032311 C10.6659594,26.8620435 10.9241898,27.6403356 11.359375,28.3671875 C11.8489583,29.1848958 12.5104167,29.8463542 13.34375,30.3515625 C14.1770833,30.8567708 15.140625,31.109375 16.234375,31.109375 Z M27.125,23.234375 L5.296875,23.234375 L5.296875,23.046875 C5.421875,22.9114583 5.58854167,22.734375 5.796875,22.515625 C6.00520833,22.296875 6.23958333,22.0546875 6.5,21.7890625 C6.76041667,21.5234375 7.01041667,21.2447917 7.25,20.953125 C7.51041667,20.6510417 7.73958333,20.3020833 7.9375,19.90625 C8.13541667,19.5104167 8.29947917,19.0598958 8.4296875,18.5546875 C8.55989583,18.0494792 8.6640625,17.4921875 8.7421875,16.8828125 C8.8203125,16.2734375 8.88020833,15.6145833 8.921875,14.90625 C8.96354167,12.84375 9.1875,11.2057292 9.59375,9.9921875 C10,8.77864583 10.5286458,7.87239583 11.1796875,7.2734375 C11.8307292,6.67447917 12.5677083,6.26041667 13.390625,6.03125 C13.5677083,5.98958333 13.7057292,5.91927083 13.8046875,5.8203125 C13.9036458,5.72135417 13.9635417,5.57291667 13.984375,5.375 C14.015625,4.61458333 14.2291667,4 14.625,3.53125 C15.0208333,3.0625 15.5572917,2.828125 16.234375,2.828125 C16.9010417,2.828125 17.4322917,3.0625 17.828125,3.53125 C18.2239583,4 18.4375,4.61458333 18.46875,5.375 C18.4895833,5.57291667 18.5494792,5.72135417 18.6484375,5.8203125 C18.7473958,5.91927083 18.8854167,5.98958333 19.0625,6.03125 C19.8854167,6.26041667 20.6223958,6.67447917 21.2734375,7.2734375 C21.9244792,7.87239583 22.4505208,8.77864583 22.8515625,9.9921875 C23.2526042,11.2057292 23.484375,12.84375 23.546875,14.90625 C23.5677083,15.6145833 23.6197917,16.2734375 23.703125,16.8828125 C23.7864583,17.4921875 23.8958333,18.0494792 24.03125,18.5546875 C24.1666667,19.0598958 24.3307292,19.5104167 24.5234375,19.90625 C24.7161458,20.3020833 24.9375,20.6510417 25.1875,20.953125 C25.4375,21.2447917 25.6927083,21.5234375 25.953125,21.7890625 C26.2135417,22.0546875 26.4453125,22.296875 26.6484375,22.515625 C26.8515625,22.734375 27.0104167,22.9114583 27.125,23.046875 L27.125,23.234375 Z M16.234375,28.875 C15.359375,28.875 14.640625,28.5911458 14.078125,28.0234375 C13.5625,27.5030382 13.2613209,26.8141457 13.1745877,25.95676 L13.158,25.75 L19.294,25.75 L19.2785373,25.95676 C19.1918041,26.8141457 18.890625,27.5030382 18.375,28.0234375 C17.8125,28.5911458 17.0989583,28.875 16.234375,28.875 Z"/>
                        </svg>
                        Notify Me
                      </button>
                    }
                    {isMiddleScienceSubscribed &&
                      <button className='discoverHome-marketBtn-inner-notificationBtn discoverHome-marketBtn-inner-notificationBtn--subscribed'>
                        Subscribed
                      </button>
                    }
                  </div>
                </div>
              </button>

            */}

          </div>

          <DiscoverExcludedMarkets
            meta={this.props.meta}
            subscribedMarkets={this.props.subscribedMarkets}
            subscribeToExcludedMarket={this.props.subscribeToExcludedMarket}
            unsubscribeToExcludedMarket={this.props.unsubscribeToExcludedMarket}
          />

          <DiscoverSubjectPageFooter
            showNotification={this.props.showNotification}
            showRequestSubject
          />

        </div>
        <div className='page-rightPanel' />
      </div>
    )
  }
}

export default withRouter(DiscoverHomePage)
